import { http } from "./http.js";

export interface ShopSummary {
  id: string;
  install_id: string;
  platform: string;
  shop_id: string;
  shop_name: string;
  enabled: boolean;
  auth_status: string;
  last_synced_at: number | null;
  app_secret_masked: string | null;
  extra_keys: string[];
  /** access_token 过期时间 — 服务器 JSON 序列化 Date 为 ISO 字符串，老数据可能是毫秒数 */
  access_token_expires_at: string | number | null;
  /** 该店铺支持一键刷新授权 */
  can_refresh: boolean;
}

export interface CreateShopInput {
  platform: string;
  shop_id: string;
  shop_name: string;
  app_secret: string;
  extra?: Record<string, string>;
  enabled?: boolean;
}

export interface UpdateShopInput {
  shop_name?: string;
  app_secret?: string;
  extra?: Record<string, string> | null;
  enabled?: boolean;
  /** ISO 日期字符串或 null（清除） */
  access_token_expires_at?: string | null;
}

export async function listShops(): Promise<ShopSummary[]> {
  const res = await http.get<{ shops: ShopSummary[] }>("/shops");
  return res.data.shops;
}

export async function createShop(input: CreateShopInput): Promise<ShopSummary> {
  const res = await http.post<{ shop: ShopSummary }>("/shops", input);
  return res.data.shop;
}

export async function updateShop(shop_pk: string, input: UpdateShopInput): Promise<ShopSummary> {
  const res = await http.patch<{ shop: ShopSummary }>(`/shops/${encodeURIComponent(shop_pk)}`, input);
  return res.data.shop;
}

export async function deleteShop(shop_pk: string): Promise<void> {
  await http.delete(`/shops/${encodeURIComponent(shop_pk)}`);
}

export async function testShopConnection(shop_pk: string): Promise<{ ok: boolean; count?: number; reason?: string }> {
  const res = await http.post<{ ok: boolean; count?: number; reason?: string }>(
    `/shops/${encodeURIComponent(shop_pk)}/test`,
  );
  return res.data;
}

export async function refreshShopToken(
  shop_pk: string,
): Promise<{ ok: boolean; expires_at?: string; reason?: string }> {
  const res = await http.post<{ ok: boolean; expires_at?: string; reason?: string }>(
    `/shops/${encodeURIComponent(shop_pk)}/refresh-token`,
  );
  return res.data;
}

export async function getWebhookUrl(shop_pk: string): Promise<{ path: string; url: string | null; platform: string }> {
  const res = await http.get<{ path: string; url: string | null; platform: string }>(
    `/shops/${encodeURIComponent(shop_pk)}/webhook-url`,
  );
  return res.data;
}
